export enum RoutePath {
  Login = '/login',
  ForgotPassword = '/forgot-password',
  Locations = '/locations',
  LocationDetails = '/locations/:id',
  Unauthorized = '/unauthorized',
  Error = '/error'
}
